import React from 'react';

// List of custom props that should NOT be passed to DOM elements
const customProps = [
  'tagId', 'tagValue', 'tagBinding', 'foreColor', 'isEditMode', 'previewMode',
  'colorMap', 'textColor', 'defaultColor', 'showZones', 'normalZoneEnd', 'warningZoneEnd',
  'customWidgetId', 'templateName', 'customComponents', 'customCanvasSize', 'customCanvasProps',
  'actionType', 'targetTagId', 'tagOperation', 'navigationTarget', 'workflowName',
  'workflowParameters', 'taskCommand', 'taskParameters', 'setValue', 'toggleValue',
  'enableWorkflow', 'enableLogging', 'watchdogTimeout', 'companyId', 'parentText',
  'isStatusLabel', 'originalOptions', 'numberFormat', 'refreshInterval', 'dataMode',
  'maxDataPoints', 'showGrid', 'showLegend', 'tagIds', 'hasValueBinding', 'valueTextMap',
  'fontWeight', 'fontFamily', 'fontSize', 'unit', 'min', 'max', 'value', 'text'
];

const Box = ({
  width = 100,
  height = 60,
  backgroundColor = 'transparent',
  borderWidth = 1,
  borderColor = '#000000',
  borderRadius = 0,
  opacity = 1,
  ...otherProps
}) => {
  // Ensure borderRadius is properly formatted
  const radiusValue = typeof borderRadius === 'number' ? borderRadius : (parseInt(borderRadius) || 0);

  // Remove 'style' and custom props from otherProps to prevent them from being passed to DOM
  const { style: _, ...tempProps } = otherProps;

  // Filter out custom props that React doesn't recognize on DOM elements
  const restProps = {};
  Object.keys(tempProps).forEach(key => {
    if (!customProps.includes(key)) {
      restProps[key] = tempProps[key];
    }
  });

  const boxStyle = {
    width: '100%',
    height: '100%',
    backgroundColor,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius: `${radiusValue}px`,
    opacity,
    boxSizing: 'border-box'
  };

  return (
    <div style={boxStyle} {...restProps} />
  );
};

export default Box;